/**
 * Imágenes del blog empresarial (Unsplash, uso editorial).
 * w=960&q=80 para balance calidad / peso.
 */
const u = (id) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=960&q=80`;

export const blogEmpresarialHeroImage = u("photo-1522071820081-009f0129c71c");

export const blogEmpresarialCategoryImages = {
  "gestion-administrativa": {
    heroImage: u("photo-1545324418-cc1a3fa10c00"),
    cardImage: u("photo-1545324418-cc1a3fa10c00"),
  },
  "transformacion-digital": {
    heroImage: u("photo-1485827404703-89b55fcc595e"),
    cardImage: u("photo-1485827404703-89b55fcc595e"),
  },
  "finanzas-corporativas": {
    heroImage: u("photo-1611974789855-9c2a0a7236a3"),
    cardImage: u("photo-1611974789855-9c2a0a7236a3"),
  },
  "estrategia-comercial": {
    heroImage: u("photo-1556761175-5973dc0f32e7"),
    cardImage: u("photo-1556761175-5973dc0f32e7"),
  },
};

/** Portadas por slug. Agregar una entrada al publicar cada artículo. */
export const blogEmpresarialCoverImages = {
  "proceso-disciplinario-reforma-laboral-2026": {
    src: u("photo-1454165804606-c3d57bc86b40"),
    alt: "Documentos corporativos y cumplimiento de normas laborales internas",
  },
  "contrato-aprendizaje-practicas-empresas-2026": {
    src: u("photo-1522071820081-009f0129c71c"),
    alt: "Equipo empresarial en formación y gestión de talento",
  },
  "plan-atraccion-talento-sostenible-negocio": {
    src: u("photo-1542744173-8e7e53415bb0"),
    alt: "Equipo directivo planificando atracción y retención de talento",
  },
  "convenios-doble-tributacion-empresas-colombia": {
    src: u("photo-1494412574643-ff11b0a5c1c3"),
    alt: "Comercio internacional y operaciones tributarias transfronterizas",
  },
  "planeacion-tributaria-calendario-2026": {
    src: u("photo-1554224155-8d04cb21cd6c"),
    alt: "Planeación financiera y calendario tributario empresarial",
  },
  "tendencias-credito-acceso-financiero-pymes": {
    src: u("photo-1563986768494-4dee2763ff3f"),
    alt: "Acceso a crédito y financiamiento para pequeñas y medianas empresas",
  },
  "costos-logisticos-cadena-abastecimiento-empresas": {
    src: u("photo-1578575437130-527eed3abbec"),
    alt: "Cadena de abastecimiento y operación logística empresarial",
  },
  "ajustes-economicos-planeacion-financiera-2026": {
    src: u("photo-1460925895917-afdab827c52f"),
    alt: "Planeación financiera empresarial y análisis de indicadores económicos",
  },
  "estrategias-recaudo-cartera-finanzas-empresas": {
    src: u("photo-1434626881859-194d67b2b86f"),
    alt: "Gestión de cartera y recaudo de cuentas por cobrar empresariales",
  },
  "obligaciones-financieras-cierre-anual-empresas": {
    src: u("photo-1543286386-713bdd548da4"),
    alt: "Cierre financiero anual y calendario de obligaciones empresariales",
  },
};
